import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Organisation } from "src/sdk/models/Organisation";
import { OrganisationService } from "src/services/OrganisationService";
import smallLogo from "../../assets/images/heart.png";
import fullLogo from "../../assets/images/logo.png";
import '../Style/index.css';
export interface UserSidebarProps {
    showNav: boolean;
}

const service = new OrganisationService()
const UserSidebar: React.FC<UserSidebarProps> = ({
    showNav,
}) => {

    const [userOrgsData, setUserOrgsData] = useState<any[]>([]);
    const [menuItems, setMenuItems] = useState<Organisation[]>([]);

    useEffect(() => {
        service.getOrganisationsByUser()
            .then(function (response) {
                console.log(response.data.data);
                setUserOrgsData(response.data);
            })
            .catch(function (error) {
                console.log("API ERROR");
                console.log(error);
            });
    }, []);

    return (
        <React.Fragment>
            <div className={`l-navbar${showNav ? ' l-show' : ''}`}>
                <nav className="custom_nav border-end">
                    <div className="container-fluid " >
                        <div className="col-12 col-md-3 col-xl-2 bd-sidebar  min-vh-100 " style={{ width: "200px" }}>
                            <div className="align-items-left text-start">
                                <div className="nav_list">
                                    <Link
                                        to={{
                                            pathname: '/ticketing',
                                        }}
                                        className="nav_logo">
                                        <span className="nav_logo-icon">
                                            {showNav
                                                ? <img src={fullLogo} />
                                                : <img style={{ height: 60, marginLeft: -20 }} src={smallLogo} />
                                            }
                                        </span>
                                    </Link>
                                    {userOrgsData.map((userOrgs, index) => {
                                        return <Link key={index}
                                            to={{
                                                pathname: '/ticketing',
                                                state: userOrgs
                                            }}
                                            className="nav_link">
                                            <button type="button" className="btn btn-transparent p-1 text-white">
                                                <span className='avatar-title bg-transparent text-reset'>
                                                    {index + 1}
                                                </span>
                                            </button>
                                            <span className="nav_name">
                                                {userOrgs.name} {userOrgs.type === "Facility" ? "(F)" : "(FG)"}
                                            </span>
                                        </Link>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </React.Fragment>
    );
};

UserSidebar.propTypes = {
};

export default withTranslation()(UserSidebar);
